<template>
  <b-card style="background-color: rgba(0, 0, 0, 0.1); width: 100%;">
    <b-row>
      <b-col cols="9">
        <div class="demo-vertical-spacing">
          <div>
            <label style="color: #ffffff; font-size: 18px;">รถยนต์</label>
            <b-progress
              value="25"
              max="100"
              precision="2"
              show-progress
              class="progress1"
              :style="{backgroundColor: 'rgba(87, 155, 254, 0.1)'}"
            />
          </div>

          <div>
            <label style="color: #ffffff; font-size: 18px;">รถจักรยานยนต์</label>
            <b-progress
              value="35"
              max="100"
              precision="2"
              show-progress
              class="progress2"
              :style="{backgroundColor: 'rgba(220, 72, 255, 0.1)'}"
            />
          </div>

          <div>
            <label style="color: #ffffff; font-size: 18px;">รถเเท็กซี่</label>
            <b-progress
              value="45"
              max="100"
              precision="2"
              show-progress
              class="progress3"
              :style="{backgroundColor: 'rgba(130, 70, 254, 0.1)'}"
            />
          </div>

          <div>
            <label style="color: #ffffff; font-size: 18px;">รถกระบะ</label>
            <b-progress
              value="55"
              max="100"
              precision="2"
              show-value
              class="progress4"
              :style="{backgroundColor: 'rgba(254, 68, 122, 0.1)'}"
            />
          </div>

          <div>
            <label style="color: #ffffff; font-size: 18px;">รถบัส</label>
            <b-progress
              value="65"
              max="100"
              precision="2"
              show-progress
              class="progress5"
              :style="[{'border': '0px solid black'},{backgroundColor: 'rgba(78, 175, 81, 0.1)'}]"
            />
          </div>
          <div>
            <label style="color: #ffffff; font-size: 18px;">รถบรรทุก</label>
            <b-progress
              value="55"
              max="100"
              precision="2"
              show-progress
              class="progress6"
              :style="[{'border': '0px solid black'},{backgroundColor: 'rgba(255, 128, 93, 0.1)'}]"
            />
          </div>
          <div>
            <label style="color: #ffffff; font-size: 18px;">รถพ่วง</label>
            <b-progress
              value="87"
              max="100"
              precision="2"
              show-progress
              class="progress7"
              :style="[{'border': '0px solid black'},{backgroundColor: 'rgba(253, 255, 1, 0.1)'}]"
            />
          </div>
        </div>
      </b-col>
      <b-col
        cols="3"
        style="text-align: center;"
        class="mt-1"
      >
        <div class="mb-1">
          <label style="color: #ffffff; font-size: 18px;">445,000 กม.</label>
        </div>
        <div class="mb-1">
          <br>
          <label style="color: #ffffff; font-size: 18px;">405,000 กม.</label>
        </div>
        <br>
        <div class="mb-1">
          <label style="color: #ffffff; font-size: 18px;">300,000 กม.</label>
        </div>
        <br>
        <div class="mb-1">
          <label style="color: #ffffff; font-size: 18px;">220,000 กม.</label>
        </div>
        <br>
        <div class="mb-1">
          <label style="color: #ffffff; font-size: 18px;">102,000 กม.</label>
        </div>
        <br>
        <div class="mb-1">
          <label style="color: #ffffff; font-size: 18px;">98,000 กม.</label>
        </div>
        <br>
        <div>
          <label style="color: #ffffff; font-size: 18px;">82,000 กม.</label>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BProgress,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BProgress,
    // BCardText,
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="css">
/* .progress1 .progress-bar{background: #579BFE;}
.progress2 .progress-bar{background: #DC48FF;}
.progress3 .progress-bar{background: #8246FE;}
.progress4 .progress-bar{background: #FE447A;}
.progress5 .progress-bar{background: #4EAF51;}
.progress6 .progress-bar{background: #FF805D;}
.progress7 .progress-bar{background: #FDFF01;} */
</style>
